import { combineReducers } from '@reduxjs/toolkit';

import { actionProgressReducer } from '../slices/actionProgress';
import { actionsReducer } from '../slices/actions';
import { balanceReducer } from '../slices/balance';
import { catalogsReducer } from '../slices/catalogs';
import { categoryReducer } from '../slices/category';
import { commandsReducer } from '../slices/commands';
import { confirmationReducer } from '../slices/confirmation';
import { connectionReducer } from '../slices/connection';
import { contentReducer } from '../slices/content';
import { datasetReducer } from '../slices/dataset';
import { dictionaryReducer } from '../slices/dictionary';
import { errorReducer } from '../slices/error';
import { formReducer } from '../slices/form';
import { graphReducer } from '../slices/graph';
import { hierarchyReducer } from '../slices/hierarchy';
import { intlReducer } from '../slices/intl';
import { menuReducer } from '../slices/menu';
import { notificationsReducer } from '../slices/notifications';
import { operationProgressReducer } from '../slices/operationProgress';
import { pivotReducer } from '../slices/pivot';
import { reviewReducer } from '../slices/review';
import { rolePrivsReducer } from '../slices/rolePrivs';
import { sessionReducer } from '../slices/session';
import { systemNotificationsReducer } from '../slices/systemNotifications';
import { themeReducer } from '../slices/theme';
import { userConfigReducer } from '../slices/userConfig';
import { workTableReducer } from '../slices/workTable';

export const rootReducer = combineReducers({
  actions: actionsReducer,
  actionProgress: actionProgressReducer,
  balance: balanceReducer,
  catalogs: catalogsReducer,
  category: categoryReducer,
  commands: commandsReducer,
  confirmation: confirmationReducer,
  connection: connectionReducer,
  content: contentReducer,
  dataset: datasetReducer,
  dictionary: dictionaryReducer,
  errors: errorReducer,
  form: formReducer,
  hierarchy: hierarchyReducer,
  menu: menuReducer,
  intl: intlReducer,
  operationProgress: operationProgressReducer,
  session: sessionReducer,
  theme: themeReducer,
  userConfig: userConfigReducer,
  notifications: notificationsReducer,
  workTable: workTableReducer,
  graph: graphReducer,
  rolePrivs: rolePrivsReducer,
  pivot: pivotReducer,
  review: reviewReducer,
  systemNotifications: systemNotificationsReducer,
});

export type AppState = ReturnType<typeof rootReducer>;
